import {
    ListarResultadoContatoService,
    GetResultadoContatoService,
    InserirResultadoContatoService,
    AtualizarResultadoContatoService,
    DeletarResultadoContatoService,
    InserirTentativaDeContatoService,
    InserirContatoNaoEfetivoService,
    InserirContatoEfetivoService,
} from "../../../Services/Cobranca/ResultadoContato/ResultadoContatoService";
import {
    IContatoEfetivo,
    IContatoNaoEfetivo,
    IResultadoContato,
    ITentativaContato,
} from "../../../Interfaces/Cobranca/ResultadoContato/ResultadoContatoInterface";
import { Controller } from "../../Controller";

export async function ListarResultadoContatoController() {
    return Controller(ListarResultadoContatoService());
}
export async function ListarResultadoContatoNaoEfetivo() {
    const Response = await ListarResultadoContatoController().then((res) => {
        return res.filter(
            (resultado) => resultado.DS_CLASSIFICACAO === "Não Efetivo"
        );
    });
    return Response;
}
export async function ListarResultadoTentativaContato() {
    const Response = await ListarResultadoContatoController().then((res) => {
        return res.filter(
            (resultado) => resultado.DS_CLASSIFICACAO === "Tentativa de Contato"
        );
    });
    return Response;
}
export async function ListarResultadoContatoEfetivo() {
    const Response = await ListarResultadoContatoController().then((res) => {
        return res.filter(
            (resultado) => resultado.DS_CLASSIFICACAO === "Contato Efetivo"
        );
    });
    return Response;
}

export async function GetResultadocontatoController(
    idResultadoContato: number
) {
    return Controller(GetResultadoContatoService(idResultadoContato));
}

export async function InserirResultadoContatoController(
    requestBody: IResultadoContato
) {
    return Controller(InserirResultadoContatoService(requestBody));
}

export async function AtualizarResultadoContatoController(
    requestBody: IResultadoContato
) {
    return Controller(AtualizarResultadoContatoService(requestBody));
}

export async function DeletarResultadoContatoController(
    idResultadoContato: number
) {
    return Controller(DeletarResultadoContatoService(idResultadoContato));
}

export async function InserirTentativaDeContatoController(
    requestBody: ITentativaContato
) {
    return Controller(InserirTentativaDeContatoService(requestBody));
}

export async function InserirContatoNaoEfetivoController(
    requestBody: IContatoNaoEfetivo
) {
    return Controller(InserirContatoNaoEfetivoService(requestBody));
}

export async function InserirContatoEfetivoController(
    requestBody: IContatoEfetivo,
    agrupar: boolean
) {
    return Controller(InserirContatoEfetivoService(requestBody, agrupar));
}
